import { FC, useMemo } from 'react';
import { Box } from '@mui/material';
import { CredentialsType, DeviceForCredentials, DevicesType } from '../types';
import { credentialsExist, getCredentials } from '../utils';
import BookingDeviceDutCredentials from './BookingDeviceDutCredentials';
import BookingDeviceTrafficGeneratorCredentials from './BookingDeviceTrafficGeneratorCredentials';

interface CredentialsProps {
    device: DeviceForCredentials;
    credentialsObject: CredentialsType;
}

const Credentials: FC<CredentialsProps> = ({ device, credentialsObject }) => {
    const credentials = useMemo(() => {
        if (device && credentialsObject && credentialsExist(credentialsObject)) {
            return getCredentials(device, credentialsObject);
        }
        return;
    }, [credentialsObject, device]);

    if (!credentials) {
        return null;
    }

    return (
        <Box mt={1}>
            {device.type === DevicesType.DUT && Array.isArray(credentials) && (
                <BookingDeviceDutCredentials credentials={credentials} deviceArchitecture={device.architecture} />
            )}
            {!Array.isArray(credentials) && (
                <BookingDeviceTrafficGeneratorCredentials credentials={credentials} selectedDevice={device} />
            )}
        </Box>
    );
};

export default Credentials;
